import { useEffect, useState } from 'react';
import { cardServedEvent } from '../../../Utils/StoreHomePageUtils';
import {
  BannerSubTitle,
  BannerTitle,
  BrowseSection,
  RelativeDiv,
  SectionHeading,
} from './styled';
import ProductCard from './ProductCard';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import { isDesktopUser } from '../../../Utils/ProductUtils';

function OfferLockedProducts(props) {
  const {
    products,
    setChangeCartCount,
    setOfferCartData,
    offerCartData,
    hideStickyStrip,
    lockedProductSectionRef,
    showLockedProductsAnimation,
    setShowAnimation,
    showB2g1Snackbar,
    setShowHeader,
    setShowTop,
    showNewCDDDPage,
  } = props;

  const [items, setItems] = useState(null);
  const [text, setText] = useState('Unlock Your Free Diaper Pack Worth ₹499!');
  const [subText, setSubText] = useState(
    'Add 2 cloth diapers to claim your Free Diaper Pant, Trusted by 100k+ moms for their babies.',
  );
  const [productList, setProductList] = useState([]);
  const [desktopUser, setDesktopUser] = useState(false);

  useEffect(() => {
    if (showNewCDDDPage) {
      setProductList(products?.items);
    } else {
      setProductList(products?.items.filter((obj) => obj.status != '4'));
    }
    cardServedEvent(products);
    setDesktopUser(isDesktopUser());
  }, []);

  useEffect(() => {
    const array = [];
    offerCartData?.productList?.map((element) => {
      let obj = {};
      if (!element?.addToCart) {
        if (element?.quantity > 1) {
          for (let i = 1; i < element?.quantity; i++) {
            obj = {
              image: element?.image,
              id: element?.id,
            };
            array.push(obj);
          }
        }
        array.push(element?.id);
      }
    });
    setItems(array);

    if (!array.length) {
      setText('Unlock Your Free Diaper Pack Worth ₹499!');
      setSubText(
        'Add 2 cloth diapers to claim your Free Diaper Pant, Trusted by 100k+ moms for their babies.',
      );
    } else if (array.length >= 2) {
      setText('Your Free Diaper Pack is Unlocked!');
      setSubText('Select the right size and enjoy your free pack');
    } else {
      setText('Just 1 More Step to Unlock!');
      setSubText(
        'Add 1 more cloth diaper to get your free diaper pack, Loved by Moms for its safety and comfort.',
      );
    }
  }, [offerCartData?.productList]);

  return (
    <div ref={lockedProductSectionRef}>
      <BrowseSection
        className={showLockedProductsAnimation ? 'shakeanimation' : ''}
        sectionBgColorEnd={products?.sectionBgColorEnd}
        sectionBgColorStart={products?.sectionBgColorStart}
        showNewCDDDPage={showNewCDDDPage}
      >
        <SectionHeading>
          <img
            src={products?.sectionBgImage}
            width="100%"
            height="140px"
            alt=""
          />
          <div className="textWrapper">
            <BannerTitle>{text}</BannerTitle>
            <BannerSubTitle>{subText}</BannerSubTitle>
          </div>
        </SectionHeading>
        <div className="horizontalLine"></div>
        {showNewCDDDPage && !desktopUser ? (
          <>
            {productList?.map((element, index) => {
              return (
                <ProductCard
                  productId={element._id}
                  data={element}
                  setChangeCartCount={setChangeCartCount}
                  sectionName={element?.name}
                  sectionId={products?.itemId}
                  key={index}
                  index={index}
                  setOfferCartData={setOfferCartData}
                  offerCartData={offerCartData}
                  hideStickyStrip={hideStickyStrip}
                  isLocked={items?.length < 2}
                  items={items}
                  setShowAnimation={setShowAnimation}
                  showB2g1Snackbar={showB2g1Snackbar}
                  setShowHeader={setShowHeader}
                  setShowTop={setShowTop}
                  showNewCDDDPage={showNewCDDDPage}
                />
              );
            })}
          </>
        ) : (
          <RelativeDiv>
            <AnywhereHorizontalScroll
              firstElementId={`0first`}
              lastElementId={`${productList?.length - 1}last`}
              scrolledWidth={500}
              isForNewCdPage={true}
            >
              {productList?.map((element, index) => {
                return (
                  <ProductCard
                    productId={element._id}
                    data={element}
                    setChangeCartCount={setChangeCartCount}
                    sectionName={element?.name}
                    sectionId={products?.itemId}
                    key={index}
                    index={index}
                    setOfferCartData={setOfferCartData}
                    offerCartData={offerCartData}
                    hideStickyStrip={hideStickyStrip}
                    isLocked={items?.length < 2}
                    items={items}
                    setShowAnimation={setShowAnimation}
                    showB2g1Snackbar={showB2g1Snackbar}
                    setShowHeader={setShowHeader}
                    setShowTop={setShowTop}
                  />
                );
              })}
            </AnywhereHorizontalScroll>
          </RelativeDiv>
        )}
      </BrowseSection>
    </div>
  );
}

export default OfferLockedProducts;
